package ru.education.building.schedule.view.states

import ru.education.building.schedule.data.models.Misis
import ru.education.building.schedule.data.models.MisisGroups

sealed interface UiState {
    data object Loading : UiState
    data class Data(val items: List<Misis>) : UiState
    data class Group(val items: List<MisisGroups>): UiState
    data class Error(val message: String) : UiState
}